import { PlacesApiClient } from '../places_api';
import { GooglePlacesApiAdapter } from '../places_api/adapters/google_places';
import { StoreAddonsNeighborhoodDecorator } from '../places_api/decorators/store_addons_neighborhood_decorator';
import { ViaCepPlacesServiceDecorator } from '../places_api/decorators/viacep_places_service_decorator';

export const createPlacesApiClient = () => {
  const googleAdapter = new GooglePlacesApiAdapter();
  const viaCepDecorator = new ViaCepPlacesServiceDecorator(googleAdapter);
  const storeDecorator = new StoreAddonsNeighborhoodDecorator(viaCepDecorator);
  return new PlacesApiClient(storeDecorator);
};
